import React, { useEffect, useState } from 'react'
import ForgotPassword from '../../../components/ForgotPassword'
import forgotPasswordValidation from './forgotPasswordValidation'
import statusFromError from './forgotPasswordStatus'
import useForm from '../useForm'
import { authApi } from '../../../api/apiNew'

const ForgotPasswordContainer = () => {
	const [status, setStatus] = useState({
		message: '',
		isLoading: false,
	})
	const [values, setValues] = useState({
		email: '',
	})
	const [errors, setErrors] = useState({
		email: '',
	})

	useEffect(() => {
		document.title = 'Восстановление пароля | Kinopoisk Api Unofficial'
	}, [])

	const handleSubmit = e => {
		e.preventDefault()
		setStatus(prevState => ({
			...prevState,
			isLoading: true,
		}))

		authApi
			.requestPasswordReset(values.email)
			.then(res => {
				setStatus(prevState => ({
					...prevState,
					message: res.status === 200 ? 'ok' : '',
				}))
			})
			.catch(err => {
				setStatus(prevState => ({
					...prevState,
					message: statusFromError(err),
				}))
			})
			.finally(() => {
				setStatus(prevState => ({
					...prevState,
					isLoading: false,
				}))
			})
	}

	const { handleChange, disabled } = useForm(
		forgotPasswordValidation,
		values,
		errors,
		setValues,
		setErrors
	)

	return (
		<ForgotPassword
			handleSubmit={handleSubmit}
			handleChange={handleChange}
			values={values}
			errors={errors}
			disabled={disabled}
			status={status}
		/>
	)
}

export default ForgotPasswordContainer
